/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
import React, { useEffect, useRef, useState } from "react";
import { useParams, Outlet, useLocation } from "react-router-dom";
// Redux Toolkit
import { useDispatch, useSelector } from 'react-redux';
import { selectUser } from '../../store/userSlice';
import { resetNavigation } from "../../store/BASE/navigationSlice";
// actions
import { getListing } from "../../actions";
// BASE Components
import BASEPageSimple from "../../../@BASE/core/BASEPageSimple";
import useThemeMediaQuery from "../../../@BASE/hooks/useThemeMediaQuery";
// material-ui
import { styled } from "@mui/material/styles";
// Custom Components
import SettingsHeader from "./SettingsHeader";
import SettingsSidebarContent from "./SettingsSidebarContent";

const Root = styled(BASEPageSimple)(() => ({
  "& .BASEPageSimple-header": {},
  "& .BASEPageSimple-sidebar": {},
  "& .BASEPageSimple-leftSidebar": {},
}));

function SettingsPage() {
  const user = useSelector(selectUser);
  const [organizations, setOrganizations] = useState(null);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const location = useLocation();
  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down("lg"));
  const pageLayout = useRef(null);
  const [leftSidebarOpen, setLeftSidebarOpen] = useState(!isMobile);

  // fetch Users
  const fetchOrganizations = async () => {
    try {
      const response = await dispatch(getListing('organizations')()).unwrap();
      setOrganizations(response);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
		setLeftSidebarOpen(!isMobile);
	}, [isMobile]);
	useEffect(() => {
		if (isMobile) {
			setLeftSidebarOpen(false);
		}
	}, [location, isMobile]);

  // get data from API on page load
  useEffect(() => {
    // get organizations
    fetchOrganizations();
    // reset navigation
    dispatch(resetNavigation());
  }, [dispatch]);

  return (
    <Root
      content={
        <div className="flex-auto p-12 md:p-32 lg:p-48">
          <SettingsHeader
            className="mb-24 md:mb-32"
            onSetSidebarOpen={setLeftSidebarOpen}
          />
          <Outlet context={{user, organizations}} />
        </div>
      }
      ref={pageLayout}
      leftSidebarOpen={leftSidebarOpen}
      leftSidebarOnClose={() => setLeftSidebarOpen(false)}
      leftSidebarContent={<SettingsSidebarContent onSetSidebarOpen={setLeftSidebarOpen} />}
      leftSidebarWidth={380}
      scroll={isMobile ? "normal" : "content"}
    />
  );
}

export default SettingsPage;
